import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { KlearlyAPKConfig } from "../../interfaces/klearlyApkConfig.interface";
import { fetchLatestApkConfig, updateApkConfig } from "./apkApi";

export interface ApkState {
  config?: KlearlyAPKConfig;
  loading: boolean;
  error?: string;
}

const initialState: ApkState = {
  config: undefined,
  loading: false,
  error: undefined,
};

export const getApkConfig = createAsyncThunk<KlearlyAPKConfig>(
  "apk/getLatest",
  async () => {
    const cfg = await fetchLatestApkConfig();
    return cfg;
  }
);

export const putApkConfig = createAsyncThunk<
  KlearlyAPKConfig,
  Partial<KlearlyAPKConfig>
>("apk/putConfig", async (partialConfig) => {
  const cfg = await updateApkConfig(partialConfig);
  return cfg;
});

const apkSlice = createSlice({
  name: "apk",
  initialState,
  reducers: {
    resetApkState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getApkConfig.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(getApkConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.config = action.payload;
      })
      .addCase(getApkConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(putApkConfig.pending, (state) => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(putApkConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.config = action.payload;
      })
      .addCase(putApkConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { resetApkState } = apkSlice.actions;

export const selectApkConfig = (state: RootState) => state.apk.config;
export const selectApkLoading = (state: RootState) => state.apk.loading;
export const selectApkError = (state: RootState) => state.apk.error;

export default apkSlice.reducer;
